<div class="select-box-container form form-no-width" [ngClass]="{'isDisabled': isDisabled}" #elementRef>
  <div class="relative hover-nudge-parent" [ngClass]="{'small-input-container': small, 'open': !closed}">
    <input (click)="open()"
           (focus)="open()"
           [ngClass]="{'small-input' : small, 'hidden': !closed, 'extended': extended}"
           [value]="formatSelectedOption(selectedOption) !== '' ? formatSelectedOption(selectedOption) : 'Kies een optie'"
           class="select-box-search pointer"
           type="text">

    <input #searchField
           (keydown)="keydown($event)"
           (ngModelChange)="countSelection($event)"
           [(ngModel)]="query"
           [disabled]="isDisabled"
           [ngClass]="{'small-input' : small, 'hidden': closed, 'extended': extended}"
           class="select-box-search"
           type="text">

    <svg class="icon hover-nudge-child pointer"
         [ngClass]="{'hidden': !closed}"
         (click)="open()"
         xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15.12 8.09">
      <path d="M15,.1a.36.36,0,0,0-.51,0l-7,7.1L.62.15A.36.36,0,0,0,.1.65L7.28,8A.36.36,0,0,0,7.8,8L15,.61A.36.36,0,0,0,15,.1Z"/>
    </svg>

  </div>
  <div *ngIf="!closed"
       [attr.data-only-option]="selection.length == 1"
       class="select-box">
    <div (click)="select(option)"
         *ngFor="let option of _options"
         [attr.data-selected]="selected(option, query)"
         class="option">
      {{labelFormatter(option)}}
    </div>
  </div>
</div>
